var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-application',_vm._b({attrs:{"multiple":"","app-types":_vm.apps},model:{value:(_vm.application),callback:function ($$v) {_vm.application=$$v},expression:"application"}},'select-application',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }